export default __webpack_public_path__ + "static/media/PhotoThumb.49f12a19.png";